// Assignees
export const selectAssigneesLoading = (state) => state.assignees.loading;
export const selectAssigneesLoadingId = (state) => state.assignees.incidentId;
